import React from 'react';
import { getAvatarFace } from '../../avatars';
import { useTutorialEncounter } from '../../redux/tutorial/selectors';
import { Icon } from '../common/Icon';
import styles from './TutorialEnemy.module.css';

export const TutorialEnemy: React.FC = () => {
  const encounter = useTutorialEncounter();

  if (!encounter) {
    return null;
  }

  const hpColor =
    encounter.hp && encounter.hp.percent > 60
      ? '#8fe26f'
      : encounter.hp && encounter.hp.percent > 30
        ? '#f0b356'
        : '#ee6b6b';

  return (
    <div className={`${styles.enemy} ${encounter.variant === 'obstacle' ? styles.obstacle : styles.combatant}`}>
      <div className={styles.avatar}>
        {encounter.avatarFileName ? (
          <Icon url={getAvatarFace(encounter.avatarFileName)} width={56} height={56} />
        ) : (
          <div className={styles.emblem}>{encounter.badge.split(' ')[0]}</div>
        )}
      </div>

      <div className={styles.details}>
        <div className={styles.metaRow}>
          <div className={styles.eyebrow}>{encounter.eyebrow}</div>
          <div className={styles.phase}>{encounter.badge}</div>
        </div>

        <div className={styles.name}>{encounter.title}</div>

        {encounter.hp && (
          <>
            <div className={styles.hpRow}>
              <span>HP</span>
              <span>
                {encounter.hp.current}/{encounter.hp.max}
              </span>
            </div>

            <div className={styles.hpTrack}>
              <div
                className={styles.hpFill}
                style={{ width: `${encounter.hp.percent}%`, backgroundColor: hpColor }}
              />
            </div>
          </>
        )}

        <div className={styles.status}>{encounter.status}</div>
      </div>
    </div>
  );
};
